export class Inventory {

  id: bigint;
  id_lager_st: number;
  lag_mandant: string;
  lag_art_typ: number;
  lag_art_num: number;
  mat_desc: string;
  lag_bestand: number;
  lag_bestand_units: number;
  reserved: number;
  lag_referenz: number;
  lag_breite: number;
  lag_hoehe: number;
  lagm_zone: string;
  lagm_platz: string;
  lagm_menge: number;
}
